module.exports = __webpack_public_path__ + "static/media/Check-pin.c9ed1c61.svg";